import { BottomSheet } from 'shared/ui/BottomSheet'
import { Text, TextAlign, TextSize, TextWeight } from 'shared/ui/Text/Text'
import cls from './GreetingFloat.module.scss'
import whale from 'shared/assets/images/whaleGreeting.png'
import { Button } from 'shared/ui/Button'
import React from 'react'
import { useEffect, useState } from 'react'
import { EmailAuthFlow } from 'features/emailAuth'
import { emailAuthEnabled } from 'features/emailAuth/config'
import {
    createGuestSession,
    notifySessionChanged,
} from 'shared/api/sessionAuth'

export const GreetingFloat = (props) => {
    const { closeGreetingFloat, isAuthenticated, open = true } = props
    const [screen, setScreen] = useState('welcome')
    const [status, setStatus] = useState('idle')
    const [error, setError] = useState('')
    const [waitingForSession, setWaitingForSession] = useState(false)

    useEffect(() => {
        if (waitingForSession && isAuthenticated) {
            closeGreetingFloat()
        }
    }, [closeGreetingFloat, isAuthenticated, waitingForSession])

    const continueWithoutLogin = async () => {
        setStatus('working')
        setError('')
        try {
            await createGuestSession()
            setWaitingForSession(true)
            notifySessionChanged()
        } catch (signInError) {
            console.error('Guest profile creation failed', signInError)
            setError('Не получилось создать профиль. Попробуй ещё раз.')
            setStatus('idle')
        }
    }

    if (screen === 'login') {
        return (
            <BottomSheet
                label="Войти в MineCards"
                onOpenChange={(open) => !open && setScreen('welcome')}
                open={open}
            >
                <EmailAuthFlow
                    mode="login"
                    onBack={() => setScreen('welcome')}
                    onComplete={() => setWaitingForSession(true)}
                />
            </BottomSheet>
        )
    }

    return (
        <BottomSheet
            dismissible={isAuthenticated}
            label="Добро пожаловать в MineCards"
            onOpenChange={(open) => !open && closeGreetingFloat()}
            open={open}
        >
            <img className={cls.FloatWhale} src={whale} alt="whale" />
            <Text
                className={cls.TitleTextFloat}
                size={TextSize.XL}
                align={TextAlign.LEFT}
                weight={TextWeight.BOLD}
            >
                О чем ты мечтаешь?
            </Text>
            <Text
                className={cls.TextFloat}
                align={TextAlign.LEFT}
                weight={TextWeight.MED}
            >
                Мир полон удивительных мечт. Давай найдём твои!
            </Text>
            <Button
                disabled={status === 'working'}
                onClick={
                    isAuthenticated ? closeGreetingFloat : continueWithoutLogin
                }
                className={cls.FloatButton}
                text={
                    status === 'working'
                        ? 'Создаём профиль…'
                        : isAuthenticated
                          ? 'Искать мечты'
                          : 'Продолжить без регистрации'
                }
            />
            {!isAuthenticated && emailAuthEnabled && (
                <button
                    className={cls.LoginButton}
                    onClick={() => setScreen('login')}
                    type="button"
                >
                    Уже пользовались MineCards? Войти
                </button>
            )}
            {error && (
                <p className={cls.Error} role="alert">
                    {error}
                </p>
            )}
        </BottomSheet>
    )
}
